/**
 * Site-wide metadata and configuration.
 * Single source of truth — never duplicated in components.
 */
export const siteConfig = {
  name: 'HUN TECH PLC',
  shortName: 'HUN TECH',
  tagline: 'Built to stand above.',
  description:
    'HUN TECH PLC delivers custom web apps, mobile solutions, and enterprise systems — built with precision for businesses that demand more.',
  url: 'https://huntech.et',
  email: 'hello@huntech.et',
  location: 'Addis Ababa, Ethiopia',
  foundedYear: 2025,
  themeStorageKey: 'hun-tech-theme',
  founder: {
    name: 'Hundaol Worku',
    nickname: 'Hun',
    role: 'Founder & CEO',
    nameLanguage: 'Oromo',
    nameMeaning: 'Above All',
  },
} as const

export type SiteConfig = typeof siteConfig
